import { render } from "./CardAddGoal.vue?vue&type=template&id=10028138"
import script from "./CardAddGoal.vue?vue&type=script&lang=js"
export * from "./CardAddGoal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Goal/CardAddGoal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10028138"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10028138', __exports__)) {
    api.reload('10028138', __exports__)
  }
  
  module.hot.accept("./CardAddGoal.vue?vue&type=template&id=10028138", () => {
    api.rerender('10028138', render)
  })

}


export default __exports__